import { ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import { StringOrNull } from 'store/entity/types';
import SurveyReportModal from 'components/FileManager/ItemsViewer/SurveyReport/SurveyReportModal';

import QuillManagerModal from 'components/FileManager/ItemsViewer/Quill/QuillManagerModal';
import SurveyManagerModal from 'components/FileManager/ItemsViewer/Survey/SurveyManagerModal';
import {
  IProviderItemViewWithData,
  providerItemType,
} from 'store/providers/providerTypes';
import DocumentViewModal from '../../../../components/FileManager/ItemsViewer/DocumentViewerModal/DocumentViewModal';
import SearchTagManagerModal from '../../../../components/FileManager/ItemsViewer/SearchTag/SearchTagManagerModal';

interface IComponentProps {
  onClose: ((item: IProviderItemViewWithData | null) => void) | null;
  dispatch: ThunkDispatch<any, never, any>;
  openItem: IProviderItemViewWithData;
  openItemProps?: any;
  showHome?: boolean;
  openNextItem?: () => void;
  showAnimation?: boolean;
}

interface IComponentStates {
  activeTab: StringOrNull;
}

class TaskItemsViewer extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  state = {
    activeTab: null,
  };

  handleChangeTab = (activeTab: string) => {
    this.setState({ activeTab });
  };

  handleCloseFunction = (e?: any) => {
    if (e) {
      e.stopPropagation();
    }
    this.props.onClose && this.props.onClose(null);
  };

  getItemView(item: IProviderItemViewWithData) {
    const { activeTab } = this.state;
    const { openItemProps, showHome, showAnimation = false } = this.props;
    const openItem = {
      item: item,
      status: activeTab
        ? activeTab
        : item.status
          ? item.status
          : item.data.type === providerItemType.survey
            ? 'responses'
            : 'view',
    };

    if (item.data.type === providerItemType.document) {
      switch (item.data.document.properties.format) {
        case 'quill':
          return (
            <QuillManagerModal
              showHome={showHome}
              key={item.data.id}
              openItem={openItem}
              changeState={this.handleChangeTab}
              dispatch={this.props.dispatch}
              isOpen={true}
              onClose={this.props.onClose ? this.handleCloseFunction : null}
              // showAnimation={showAnimation}
              {...openItemProps}
            />
          );
        default:
          return (
            <DocumentViewModal
              showHome={showHome}
              key={item.data.id}
              openItem={openItem}
              changeState={this.handleChangeTab}
              dispatch={this.props.dispatch}
              isOpen={true}
              onClose={this.props.onClose ? this.handleCloseFunction : null}
              // showAnimation={showAnimation}
              {...openItemProps}
            />
          );
        // redirectTo(item.data.document.url);
        // return (
        //   <span>
        //     <a href={item.data.document.url}>{messages.download}</a>
        //   </span>
        // );
      }
    } else if (item.data.type === providerItemType.survey) {
      return (
        <SurveyManagerModal
          showHome={showHome}
          key={item.data.id}
          openItem={openItem}
          changeState={this.handleChangeTab}
          dispatch={this.props.dispatch}
          isOpen={true}
          onClose={this.props.onClose ? this.handleCloseFunction : null}
          showAnimation={showAnimation}
          {...openItemProps}
          openNextItem={this.props.openNextItem}
        />
      );
    } else if (item.data.type === providerItemType.searchTag) {
      return (
        <SearchTagManagerModal
          key={item.data.id}
          openItem={openItem}
          changeState={this.handleChangeTab}
          dispatch={this.props.dispatch}
          isOpen={true}
          onClose={this.props.onClose ? this.handleCloseFunction : null}
          // showAnimation={showAnimation}
          {...openItemProps}
        />
      );
    } else if (item.data.type === providerItemType.surveyReport) {
      return (
        <SurveyReportModal
          key={item.data.id}
          openItem={openItem}
          dispatch={this.props.dispatch}
          isOpen={true}
          onClose={this.props.onClose ? this.handleCloseFunction : null}
          showAnimation={showAnimation}
          {...openItemProps}
        />
      );
    }
    return null;
  }

  render() {
    const { openItem } = this.props;
    if (openItem.data.type === 'externalLink')
      window.open(openItem.data.url, '_blank');
    return <div>{this.getItemView(openItem)}</div>;
  }
}

export default TaskItemsViewer;
